"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.buyMarketOutcome = void 0;
var abi_1 = require("@ethersproject/abi");
var FixedProductMarketMaker_json_1 = __importDefault(require("../abi/FixedProductMarketMaker.json"));
var utils_1 = require("../utils");
var types_1 = require("../types");
var encodeBuy = function (investmentAmount, outcomeIndex, minOutcomeTokensToBuy) {
    return new abi_1.Interface(FixedProductMarketMaker_json_1.default).encodeFunctionData("buy(uint256,uint256,uint256)", [
        investmentAmount,
        outcomeIndex,
        minOutcomeTokensToBuy,
    ]);
};
var buyTransaction = function (marketMakerAddress, investmentAmount, outcomeIndex, minOutcomeTokensToBuy) { return ({
    to: marketMakerAddress,
    typeCode: types_1.CallType.Call,
    data: encodeBuy(investmentAmount, outcomeIndex, minOutcomeTokensToBuy),
    value: "0",
}); };
exports.buyMarketOutcome = function (marketMakerAddress, collateralTokenAddress, investmentAmount, outcomeIndex, minOutcomeTokensToBuy) { return [
    utils_1.erc20ApprovalTransaction(collateralTokenAddress, marketMakerAddress, investmentAmount),
    buyTransaction(marketMakerAddress, investmentAmount, outcomeIndex, minOutcomeTokensToBuy),
]; };
